import { useCallback, useEffect, useState } from 'react';
import { getLandingSamplePlayUrl } from './demoGame';
import { loadLandingSampleGames } from './landingGames';

export function useRandomSampleGame() {
  const [sampleGames, setSampleGames] = useState([]);
  const [selectedGame, setSelectedGame] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    let isMounted = true;

    loadLandingSampleGames().then((games) => {
      if (!isMounted || games.length === 0) return;
      setSampleGames(games);
    });

    return () => {
      isMounted = false;
    };
  }, []);

  const openRandomSample = useCallback(() => {
    if (sampleGames.length === 0) return;

    const game = sampleGames[Math.floor(Math.random() * sampleGames.length)];
    setSelectedGame(game);
    setIsOpen(true);
  }, [sampleGames]);

  const closeSample = useCallback(() => {
    setIsOpen(false);
  }, []);

  const playUrl = selectedGame ? getLandingSamplePlayUrl(selectedGame) : '';
  const title = selectedGame?.name ? `Try ${selectedGame.name}` : 'Try a sample game';

  return {
    closeSample,
    hasSamples: sampleGames.length > 0,
    isOpen,
    openRandomSample,
    playUrl,
    title,
  };
}
